import { render, staticRenderFns } from "./drugSafeRemianConfig.vue?vue&type=template&id=5dcd9b00&scoped=true&"
import script from "./drugSafeRemianConfig.vue?vue&type=script&lang=js&"
export * from "./drugSafeRemianConfig.vue?vue&type=script&lang=js&"
import style0 from "./drugSafeRemianConfig.vue?vue&type=style&index=0&id=5dcd9b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd9b00",
  null
  
)

export default component.exports